const settings = {
    "AssetBase" : "/dist/",
    
};
export default settings;